import React from 'react';
import * as S from './image.atom.style';
import { DraggableComponents } from '../../../../common/types/checkout';

export type ComponentPreviewProps = {
  component: DraggableComponents;
};

export const ClassicCheckoutImage: React.FC<ComponentPreviewProps> = ({
  component,
}) => {
  return (
    <S.ImageWrapper>
      <S.PreviewImage src={component?.content} alt="Component" />
    </S.ImageWrapper>
  );
};
